import React from "react";

export default function Web_SQL() {
  return (
    <div>
      <h1>What is SQL</h1>
      <p>
        Route: <code>/web/sql</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
